import { clsx } from 'clsx';

interface CheckboxProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  disabled?: boolean;
}

export function Checkbox({ checked, onChange, className, disabled = false }: CheckboxProps) {
  return (
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={clsx(
        'w-5 h-5 rounded border-2 border-border',
        'checked:bg-primary checked:border-primary',
        'focus:ring-2 focus:ring-primary focus:ring-offset-2',
        'cursor-pointer disabled:cursor-not-allowed disabled:opacity-50',
        'transition-colors',
        className
      )}
    />
  );
}
